<template>
  <div>
    <h2>{{ title }}</h2>
    <template>
      <v-system-bar class="branch-data">
        <v-spacer></v-spacer>
        <input-search />
        <circle-button @click.native="clearServiceAreaData" />
      </v-system-bar>
    </template>
    <template>
      <v-simple-table class="branch-data">
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center" v-for="header in headers" :key="header.id">
                {{ header.text }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in dataTable" :key="item.id">
              <td align="center">{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
              <td>
                {{
                  item.branch ? item.branch.branch_name_th + "-" + item.branch.branch_name_en : ""
                }}
              </td>
              <td>{{ item.floor ? item.floor.floor_number : "" }}</td>
              <td>{{ item.name_th + " (" + item.name_en + ")" }}</td>
              <td>{{ item.updated_at | moment("DD-MM-YYYY") }}</td>
              <td>
                <a @click="showServiceArea(item.id)">
                  <icon-pencil />
                </a>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </template>
    <paginate :length="dataPaginate.last_page"
              :page="dataPaginate.current_page"
              @update="changePage">
    </paginate>
  </div>
</template>

<script>
import IconPencil from "../../../components/Icon/icon-pencil";
import InputTextField from "../../../components/Input/InputTextField";
import CircleButton from "../../../components/Button/CircleButton";
import InputSearch from "../../../components/Input/InputSearch";
import Paginate from "../../../components/Layout/Paginate";
export default {
  name: "ServiceAreaTable",
  components: {Paginate, InputSearch, CircleButton, InputTextField, IconPencil },
  data() {
    return {
      title: "Service Area",
      headers: [
        { id: 1, text: "No." },
        { id: 2, text: "Branch" },
        { id: 3, text: "Floor" },
        { id: 4, text: "Service area" },
        { id: 5, text: "Update date" },
        { id: 6, text: "edit" }
      ],
      dataTable: [],

      dataPaginate: {
        current_page: 1,
        from: 1,
        last_page: 1,
        per_page: 1,
        total: 1,
        to: 1
      }
    };
  },
  created() {
    this.getServiceAreaTable(1);
  },
  methods: {
    goToServiceAreaEdit() {
      this.$router.push("/services-area/edit");
    },
    getServiceAreaTable(page) {
      this.$store
        .dispatch("ServicesArea/getServiceArea", page)
        .then(res => {
          if (res.response_code == 200) {
            this.dataTable = res.result.data;
            this.dataPaginate = {
              current_page: res.result.current_page,
              from: res.result.from,
              last_page: res.result.last_page,
              per_page: res.result.per_page,
              total: res.result.total,
              to: res.result.to
            }
          } else {
            alert(res.response_msg);
          }
        })
        .catch(() => {
          alert("cannot to get data");
        });
    },
    changePage(val){
      this.dataPaginate.current_page = val;
      this.$store.dispatch("ServicesArea/getServiceArea", this.dataPaginate.current_page).then(res => {
        if (res.response_code == 200) {
          this.dataTable = res.result.data;
          this.dataPaginate = {
            current_page: res.result.current_page,
            from: res.result.from,
            last_page: res.result.last_page,
            per_page: res.result.per_page,
            total: res.result.total,
            to: res.result.to
          }
        } else {
          alert(res.response_msg);
        }
      });
    },
    showServiceArea(id) {
      this.$store.dispatch("ServicesArea/showServiceArea", id).then(res => {
        if (res.response_code == 200) {
          this.$store.dispatch("ServicesArea/setFormServiceArea", res.result).then(() => {
            this.goToServiceAreaEdit();
          });
        } else {
          alert(res.response_msg);
        }
      });
    },
    clearServiceAreaData() {
      this.$store.dispatch("ServicesArea/clearFormData").then(() => {
        this.goToServiceAreaEdit();
      });
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/table.css";
.branch-data {
  background-color: #e5e5e5;
  margin: 20px;
}
</style>
